var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1367 9.4707C19.8398 8.94336 20.4727 8.31055 20.9648 7.57227C20.332 7.85352 19.5938 8.06445 18.8555 8.13477C19.6289 7.67773 20.1914 6.97461 20.4727 6.0957C19.7695 6.51758 18.9609 6.83398 18.1523 7.00977C17.4492 6.27148 16.5 5.84961 15.4453 5.84961C13.4062 5.84961 11.7539 7.50195 11.7539 9.54102C11.7539 9.82227 11.7891 10.1035 11.8594 10.3848C8.80078 10.209 6.05859 8.73242 4.23047 6.51758C3.91406 7.04492 3.73828 7.67773 3.73828 8.38086C3.73828 9.64648 4.37109 10.7715 5.39062 11.4395C4.79297 11.4043 4.19531 11.2637 3.70312 10.9824V11.0176C3.70312 12.8105 4.96875 14.2871 6.65625 14.6387C6.375 14.709 6.02344 14.7793 5.70703 14.7793C5.46094 14.7793 5.25 14.7441 5.00391 14.709C5.46094 16.1855 6.83203 17.2402 8.44922 17.2754C7.18359 18.2598 5.60156 18.8574 3.87891 18.8574C3.5625 18.8574 3.28125 18.8223 3 18.7871C4.61719 19.8418 6.55078 20.4395 8.66016 20.4395C15.4453 20.4395 19.1367 14.8496 19.1367 9.96289C19.1367 9.78711 19.1367 9.64648 19.1367 9.4707Z",
    fill: "#111827"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.9e9fde11de22548088bf88b2f218bed7.svg";
export { ForwardRef as ReactComponent };